import { createCollection } from '@rocketlane/state-db';
import { EventSource } from 'api/project';
import { TeamsAPI } from 'api/teams';
export const teamsCollection = createCollection({
    id: 'teams',
    getKey: (team)=>team.teamId,
    isNewer: ()=>true,
    onInsert: async ({ modified })=>{
        if (modified == null) {
            throw new Error('teamsCollection.insert: missing team payload');
        }
        if (modified.projectId != null) {
            return TeamsAPI.createProjectTeam({
                teamName: modified.teamName,
                teamType: modified.teamType,
                roleId: modified.roleId,
                projectId: modified.projectId,
                teamSource: EventSource.PlaceholderManage,
                projectFinancialsBudgetIds: modified.budgetIds
            });
        }
        return TeamsAPI.createTeam({
            teamName: modified.teamName,
            teamType: modified.teamType,
            roleId: modified.roleId
        });
    },
    onUpdate: async ({ id, changes })=>{
        const teamId = id;
        return TeamsAPI.updateTeam(teamId, {
            teamName: changes === null || changes === void 0 ? void 0 : changes.teamName,
            roleId: changes === null || changes === void 0 ? void 0 : changes.roleId
        });
    },
    onDelete: async ({ id })=>{
        await TeamsAPI.deleteTeam(id);
    }
});
